import React from "react";
import {AiOutlineTable} from "react-icons/ai";
import { TextField, Autocomplete, Select } from "@mui/material";
import { Button } from "@mui/material";
import { MenuItem } from "@mui/material";
import { useState, useEffect } from "react";
import "./CreatedLoans.css";
import Sidebar from "../../../Sidebar/Sidebar";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsPencilSquare } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {url} from '../../../App'
import Cookies from 'js-cookie';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Tooltip from '@mui/material/Tooltip';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaFileExcel } from "react-icons/fa";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const FilterModal = ({ open, handleClose, handleFilter, sourceName, setSourceName, branchName, setBranchName,loanStatus,setLoanStatus }) => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [usersArr, setUsersArr] = useState([]);
  const [branchArr, setBranchArr] = useState([]);
  const [loanStatusArr, setloanStatusArr] = useState([]);
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');

  const handleSubmit = (e) => {
    const filters = {};
    if (sourceName) filters.loan_sourcecode = sourceName;
    if (branchName) filters.loan_branchname = branchName;
    if (loanStatus) filters.loan_status = loanStatus;
    if (fromDate) filters.from_date = fromDate;
    if (toDate) filters.to_date = toDate;
    handleFilter(filters);
    handleClose();
  };

  const handleReset = () => {
    setSourceName('');
    setBranchName('');
    setLoanStatus('');
    setFromDate('');
    setToDate('');
    const filters = {};
    handleFilter(filters);
    handleClose();
  };

  const sourceCodeSuggestions = async (inputValue) => {
    if (!inputValue) return;
    // console.log(inputValue);
    try {
      const data = await axios.get(`${url}/loan/filter/${inputValue}`,
        { headers: {token: token, email: email} }
      );
      // console.log(data.data);
      if(!data.data.auth) {
        toast.error(data.data.message);
        return;
      }
      if(data.data.auth) {
        setUsersArr(data.data.message);
        return;
      }
    } catch (error) {
      return;
    }
  }

  // const branchSuggestions = async (inputValue) => {
  //   if (!inputValue) return;
  //   // console.log(inputValue);
  //   try {
  //     const data = await axios.get(`${url}/loan/filter1/${inputValue}`,
  //       { headers: {token: token, email: email} }
  //     );
  //     // console.log(data.data);
  //     if(!data.data.auth) {
  //       toast.error(data.data.message);
  //       return;
  //     }
  //     if(data.data.auth) {
  //       setBranchArr(data.data.message);
  //     }
  //   } catch (error) {
  //     return;
  //   }
  // }

  const fetchBranchNames = async () => {
    try {
      const branches = await axios.get(`${url}/borrower/active/branches`, {
        headers: { token, email }
      });

      console.log(branches);
      if (branches.data.auth) {
        setBranchArr(branches.data.message.map((item) => item.branch_name));
      } else {
        toast.error(branches.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    if (open) {
      fetchBranchNames();
    }
   //eslint-disable-next-line
  }, [open]);

  const loanStatusSuggestions = async (inputValue) => {
    if (!inputValue) return;
    // console.log(inputValue);
    try {
      const data = await axios.get(`${url}/loan/filter2/${inputValue}`,
        { headers: {token: token, email: email} }
      );
      // console.log(data.data);
      if(!data.data.auth) {
        toast.error(data.data.message);
        return;
      }
      if(data.data.auth) {
        setloanStatusArr(data.data.message);
      }

    } catch (error) {
      return;
    }
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <h2 id="modal-title">Filter</h2>
        <Autocomplete
          freeSolo
          options={usersArr}
          inputValue={sourceName}
          onInputChange={(event, newValue) => {
            setSourceName(newValue);
            sourceCodeSuggestions(newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Source Code"
              fullWidth
              margin="normal"
            />
          )}
        />
        {/* <Autocomplete
          freeSolo
          options={branchArr}
          inputValue={branchName}
          onInputChange={(event, newValue) => {
            setBranchName(newValue);
            branchSuggestions(newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Branch Name"
              fullWidth
              margin="normal"
            />
          )}
        /> */}

        <Select
          label="Branch Name"
          value={branchName}
          onChange={(e) => setBranchName(e.target.value)}
          fullWidth
          displayEmpty
          margin="normal"
        >
          <MenuItem value="" disabled>
            Select Branch
          </MenuItem>
          {branchArr.map((branch, index) => (
            <MenuItem key={index} value={branch}>
              {branch}
            </MenuItem>
          ))}
        </Select>

        <Autocomplete
          freeSolo
          options={loanStatusArr}
          inputValue={loanStatus}
          onInputChange={(event, newValue) => {
            setLoanStatus(newValue);
            loanStatusSuggestions(newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Loan Status"
              fullWidth
              margin="normal"
            />
          )}
        />
        <TextField
          label="From Date"
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            max: new Date().toISOString().split("T")[0],
          }}
        />
        <TextField
          label="To Date"
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            max: new Date().toISOString().split("T")[0],
          }}
        />
        <Button variant="contained" onClick={handleSubmit} style={{ marginTop: '20px' }}>Apply Filter</Button>
        <Button variant="outlined" onClick={handleReset} style={{ marginTop: '20px', marginLeft: '10px' }}>Reset Filter</Button>
      </Box>
    </Modal>
  );
};

const CreatedLoans = () => {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const [loans, setLoans] = useState([]);
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  const [rowNumber, setRowNumber] = useState(10);
  var [pageCount, setPageCount] = useState(1);
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [visible, setvisible] = useState(false);
  const [EditLoanVisible, setEditLoanVisible] = useState(false);
  const [query, setQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sourceName, setSourceName] = useState('');
  const [branchName, setBranchName] = useState('');
  const [loanStatus, setLoanStatus] = useState('');
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [filters, setFilters] = useState({});

  useEffect(() => {
      if (email === "rupesh.bishnoi@credin.in") {
        setvisible(true);
      } else{
      axios
      .post(url + "/user/getsingle", {
        token: token,
        email: email,
        useremail:email
      })
      .then((res) => {
        // console.log(res);
        setEditLoanVisible(res.data[0].permission.edit_loan);
      })
      .catch((err) => {
        // console.log(err);
      })};
      console.log(filters,"filters")
      if (Object.keys(filters).length > 0) {
        const fetchData = async () => {
          try {
            setOpen(true);
            const response = await axios.post(url + "/loan/filterloan", {
              token: token,
              email: email,
              ...filters,
              pageSize: rowNumber,
              page: pageCount,
            });
            // console.log(response.data);
            setOpen(false);
            if (response.data.message.length === 0 && pageCount > 1) return setPageCount((pageCount) => pageCount - 1);
            setLoans(response.data.message);
          } catch (error) {
            console.error('Error fetching data:', error);
            setOpen(false);
          }
        };
        fetchData();
      } else {
      setOpen(true)
      axios
        .post(url + "/loan/getall", {
          token: token,
          email: email,
          pageSize: rowNumber,
          page: pageCount
        })
        .then((res) => {
           console.log(res)
          if(res.data.logout===true){
            setOpen(false)
            setTimeout(() => {
              toast.error(res.data.message);
            navigate("/");
            }, 3000);
          }
          else if (res.data.auth === false) {
            setOpen(false)
            // toast.error(res.data.message);
          } else {
            setOpen(false)
            if(res.data.message.length === 0 && pageCount>1) return setPageCount((pageCount)=>pageCount-1);
            setLoans(res.data.message);
            // console.log(res.data.message);
          }
        })
        .catch((err) => {
          setOpen(false)
          // console.log(err);
        });
      }
      //eslint-disable-next-line
    }, [token,email,rowNumber,pageCount,navigate]);

  const paginationViewHandler = (e) => {
    parseInt(setRowNumber(e.target.value));
  };

  const getPageLoad = (e) => {
    // setOpen(true);
    if(e === "inc"){
      setPageCount((pageCount)=>pageCount+1);
    }else{
      setPageCount((pageCount)=>pageCount-1);
    }
  }

  const serachDateApi = () =>{
    setOpen(true)
    axios
      .post(url + "/loan/search", {
        token: token,
        email: email,
        borrowerUniqueNo: query
      })
      .then((res) => {
         console.log(res)
        if (res.data.auth === false) {
          setOpen(false);
          setTimeout(() => {
            window.location.reload();
          }, 3000);
          toast.error(res.data.message);
        } else {
          setOpen(false)
          if(res.data.message.length === 0) return setLoans([])
          setLoans(res.data.message);
          console.log(res.data);
        }
      })
      .catch((err) => {
        setOpen(false)
        // console.log(err);
        toast.error(err.message);
      });
  }

  const formattedDate = (date) => {
    let formatDate;
    if (date) {
        const dateObj = new Date(date);
        const day = dateObj.getUTCDate().toString().padStart(2, '0');
        const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
        const year = dateObj.getUTCFullYear();
        formatDate = `${day}-${month}-${year}`;
    }
    return formatDate;
  }

  const handleFilter = (filters) => {
    try {
      setFilters(filters);
      console.log(filters)
      setIsFilterApplied(Object.keys(filters).length > 0);
      setOpen(true);
      axios
        .post(url + "/loan/filterloan", {
          token: token,
          email: email,
          ...filters,
          pageSize: rowNumber,
          page: pageCount,
        })
        .then((res) => {
          // console.log(res);
          setLoans(res.data.message);
          setOpen(false);
          return;
        })
        .catch((err) => {
          setOpen(false);
          toast.error(err.message);
          return;
        });
    } catch (err) {
      console.log(err);
    }
  }

  const handleOpenModal = () => {
    setIsModalOpen(true);
  }

  const handleCloseModal = () => {
    setIsModalOpen(false);
  }

  const handleDownloadExcel = async () => {
    setOpen(true);
    try {
      if (!loans || loans.length === 0) {
        toast.warning("No Loan Data available to Download.");
        return;
      }

      const formattedData = loans.map((loan) => ({
        "Loan Id": loan?.loan_id,
        "Borrower Name": loan?.borrower_name,
        "Loan Product Name": loan?.loanproduct_name,
        "Principal Amount": loan?.loan_principal_amt,
        "NBFC Name": loan?.nbfc_name,
        "Staff Name": loan?.loan_sourcename,
        "Staff ID": loan?.loan_sourcecode,
        "Branch Name": loan?.loan_branchname,
        "Loan Created": formattedDate(loan?.loan_created_date),
        "Status": loan?.loan_status
      }));
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Loan");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });

      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });

      saveAs(data, `Loan_Data.xlsx`);
      toast.success("Excel file Downloaded Successfully.");
    } catch (err) {
      console.error("Excel download failed:", err);
      toast.error("Failed to download Excel");
    } finally {
      setOpen(false);
    }
  };

  return (
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} dataSend={"ViewLoans"} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container">
            <h3 className="main-heading">
              <AiOutlineTable />
              View Loans
            </h3>
            <div className="table-createdLoans-input-fields">
              <div className="table-head-inputs-loans">
                <TextField
                  placeholder="Borrower Id / Loan Id"
                  name="search-data"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  id="search-data"
                  variant="outlined"
                  size="small"
                  sx={{
                    width: "500px",
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '16px', 
                    }
                  }}
                />
              </div>
              <button className="digi-kyc" onClick={serachDateApi}>Search</button> 
              <Tooltip title="Filter Loans">
                <button style={{ background: "#034ea1", color: "#fff", borderRadius: "3px", cursor: "pointer", }} onClick={handleOpenModal}>
                  {isFilterApplied ? <FilterAltIcon /> : <FilterAltOffIcon />}
                </button>
              </Tooltip>
              <FilterModal
                open={isModalOpen}
                handleClose={handleCloseModal}
                handleFilter={handleFilter}
                sourceName={sourceName}
                setSourceName={setSourceName}
                branchName={branchName}
                setBranchName={setBranchName}
                loanStatus={loanStatus}
                setLoanStatus={setLoanStatus}
              />
              <Tooltip title="Download Excel">
                <button className="excel-btn-loan" onClick={handleDownloadExcel}>
                  <FaFileExcel style={{ color: "green", fontSize: "25px" }} />
                </button>
              </Tooltip>
            </div>
            <div className="lms-table-div">
              <table className="lms-table">
                <thead>
                  <tr>
                    <th>Loan Id</th>
                    <th>Borrower Name</th>
                    <th>Loan Product Name</th>
                    <th>Principal Amount</th>
                    <th>NBFC Name</th>
                    {/* <th>Source</th> */}
                    <th>Staff Name</th>
                    <th>Branch Name</th>
                    {/* <th>Loan Officer</th> */}
                    <th>Loan Created</th>
                    <th>Status</th>
                    {(EditLoanVisible || visible) && (
                    <th>Actions</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {loans.length > 0 &&
                  loans?.map((loan, index) => {
                      return (
                        <tr key={index}>
                          <td>{loan.loan_id}</td>
                          <td className="hover-td"
                              onClick={() => {
                                navigate(`/borrower/detail/${loan.loan_id}`);
                                localStorage.setItem(
                                  "uniqueID",
                                  loan.borrower_uniqueno
                                );
                              }}
                            style={{
                              wordWrap: "break-word",
                              maxWidth: "150px",
                            }}
                          >
                            {loan.borrower_name}
                          </td>
                          <td>{loan.loanproduct_name}</td>
                          <td>{loan.loan_principal_amt}</td>
                          <td>{loan.nbfc_name}</td>
                          {/* <td>
                            <div className="staff-info">
                              <span className="staff-name">{loan?.matched_users?.staff_name.toUpperCase()}</span>
                              <span className="staff-id">{loan?.matched_users?.staff_id}</span>
                            </div>
                          </td> */}
                          <td>
                            <div className="staff-info">
                              <span className="staff-name">{loan?.loan_sourcename}</span>
                              <span className="staff-id">{loan?.loan_sourcecode}</span>
                            </div>
                          </td>
                          <td>{loan.loan_branchname}</td>
                          <td>
                            {formattedDate(loan.loan_created_date)}
                          </td>
                          <td>
                            {loan.loan_status}
                          </td>
                          {(EditLoanVisible || visible) && (
                          <td className="table-btn-col">
                             {(EditLoanVisible || visible) && (
                            <Link to="/loan/edit" state={loan}>
                            <button className="table-icon-btn" title="Edit">
                              <BsPencilSquare />
                            </button>
                            </Link>
                             )}
                          </td>
                           )}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className="pagination-div">
              <div className="pagination-select">
                <label>Entries To Display</label>
                <TextField
                  className=""
                  placeholder="rows"
                  select
                  name="created-data"
                  variant="outlined"
                  value={rowNumber}
                  size="small"
                  onChange={paginationViewHandler}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </TextField>
              </div> 
              <div className="pagination-bar">
              <button className="digi-kyc" style={{marginLeft:"1rem"}} onClick={() => getPageLoad("dec")} disabled={pageCount === 1}>Previous</button>
              </div>
              <span className="pageCount" style={{ margin: "1rem" }}>{ pageCount }</span>
              <div className="pagination-bar">
                <button className="digi-kyc" onClick={() => getPageLoad("inc")}>Next</button>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      </div>
    </>
  );
};

export default CreatedLoans;